import { ReactNode } from 'react';
import { View } from 'react-native';

export const ProgressLayout = ({ children }: { children: ReactNode }) => {
  return (
    <View className="w-full flex-row justify-center items-center p-1">
      {children}
    </View>
  );
};
